webpackJsonp([9],{

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
__webpack_require__(30);
__webpack_require__(1);
module.exports = __webpack_require__(31);


/***/ }),

/***/ 30:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

var loading = false;
$(function () {
    $(window).scroll(function () {
        if ($(document).scrollTop() >= $(document).height() - $(window).height()) {
            if (loading) return;
            var page = parseInt($('.news-items').attr('data-page')) || 1;
            getList(page + 1);
        }
    });
})

function getList(page) {
    loading = true;
    var path = location.pathname;
    $.get(path + '?page=' + page, function (html) {
        if (html) {
            $('.news-items').append($(html).find('.news-items').html())
            $('.news-items').attr('data-page', page)
        }
        loading = false;
    })
}

/***/ })

},[29]);


// WEBPACK FOOTER //
// js/news9257c6.js